








import {
  defineComponent,
  computed
} from '@vue/composition-api'

import { applyReactInVueWithOptions } from '@/utils/react.utils'
import { GrootNotificationBanner } from 'groot-components'

import { CfAnslAddressSearch } from '@/types/ansl-space/types/cf-ansl-address-search'
import { Entry } from 'contentful'

import {
  accessorFactory,
  Namespace
} from '@/store'

const {
  fetchContent: fetchAddressSearchContent,
  getContent: getAddressSearchContent
} = accessorFactory<Entry<CfAnslAddressSearch>>(Namespace.AddressSearchContent)

export default defineComponent({
  name: 'NotificationBannerWrapper',

  components: {
    GrootNotificationBanner: applyReactInVueWithOptions(GrootNotificationBanner)
  },

  setup (_, context) {
    const store = context.root.$store

    // Fetch the content from the store (CMS or similar)
    fetchAddressSearchContent(store)

    const addressSearchContent = computed(() => getAddressSearchContent(store))
    const showInfoAlert = computed(() => addressSearchContent.value?.fields?.showInfoAlert)
    const title = computed(() => addressSearchContent.value?.fields?.title)
    const description = computed(() => addressSearchContent.value?.fields?.description)
    const link = computed(() => addressSearchContent.value?.fields?.link?.fields)

    return {
      showInfoAlert,
      title,
      description,
      link
    }
  }
})
